<template>
  <thead>
    <tr>
      <th class="tab-wid-80" colspan="3">№<br />п/п</th>
      <th class="tab-wid-730">Название документа</th>
      <th>Формат файла</th>
      <th>Версия</th>
      <th>Дата загрузки</th>
      <th class="tc-main">Соответствие документа</th>
      <th>Дата акцепта</th>
      <th>Сотрудник Фонда</th>
      <th></th>
      <th>ЭЦП</th>
      <th>Подписант</th>
      <th></th>
      <th></th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "TableHead"
};
</script>

<style scoped></style>
